module.exports = __webpack_public_path__ + "static/img/test-cancer.c87eadb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/reproductive/test-cancer.jpg
// module id = 57AL
// module chunks = 0